<template>
  <b-modal :id="'openDocument' + parentType" class="package-modal text-center" @shown="addHtmlToIframe" @hidden="$emit('resetModalProps')"
           size="xl">
    <template slot="modal-title">
      <div v-html="$parent.documentName"></div>
    </template>
    <iframe :id="'showDocument' + parentType" width="100%" height="100%"></iframe>
    <template slot="modal-footer">
      <b-button @click="printDocument">Распечатать</b-button>
      <b-button v-if="(!$parent.documentFileName && $parent.documentName && ($parent.documentName.toLowerCase().indexOf('с решением') !== -1))" @click="downloadCommisionShipmentDecision({ decision: true })">
        <div class="d-flex align-items-center justify-content-center">
          <b-spinner type="grow" small label="Загружается..." class="mr-3"></b-spinner><span>Идёт загрузка...</span>
        </div>
      </b-button>
      <b-button v-if="($parent.documentXml && ($parent.documentXml.length > 0) && ($parent.documentName) && ($parent.documentName.indexOf('с решением') === -1))" @click="downloadDocumentXml">Скачать в XML</b-button>
      <b-button v-if="($parent.documentName && ($parent.documentName.indexOf('с решением') !== -1))" @click="downloadDocumentXml">Скачать XML решения</b-button>
    </template>
  </b-modal>
</template>

<script>
  import { getCommissionShipmentDecisionMixin } from '../mixins/getCommissionShipmentDecisionMixin'
  import html2pdf from './../../../node_modules/html2pdf.js/dist/html2pdf.js'
  export default {
    name: "OpenDocumentEcr",
    mixins: [getCommissionShipmentDecisionMixin],
    props: ['parentType'],
    data () {
      return {
        busyCommisionShipment: false
      }
    },
    methods: {
      addHtmlToIframe () {
        document.getElementById('showDocument' + this.parentType).contentWindow.document.open()
        document.getElementById('showDocument' + this.parentType).contentWindow.document.write(this.$parent.documentHtml)
        document.getElementById('showDocument' + this.parentType).contentWindow.document.close()
        document.getElementById('openDocument' + this.parentType  + '___BV_modal_content_').setAttribute('style', 'height: ' + (window.innerHeight - 100) + 'px')
      },
      printDocument () {
        document.getElementById('showDocument' + this.parentType).contentWindow.print()
      },
      downloadDocumentPdf () {
        let temp = document.createElement('div')
        temp.innerHTML = this.$parent.documentHtmlForPdf
        document.getElementById('content').appendChild(temp)
        temp.setAttribute('id', 'download-pdf')
        temp.setAttribute('style', 'position: absolute; left: 0; top: 0; right: 0; bottom: 0; display: none')
        const opt = {
          margin: 0,
          filename: this.$parent.documentName + '.pdf',
          image: { type: 'jpeg', quality: 0.96 },
          html2canvas: { scale: 2, width: 794, scrollY: 0, scrollX: 0 },
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
        }

        setTimeout(() => {
          import('../../../node_modules/html2pdf.js/dist/html2pdf.js').then(html2pdf => {
            html2pdf.default().set(opt).from(document.getElementById('download-pdf').innerHTML).save().then(() => {
              const pdf = document.getElementById('download-pdf')
              pdf.parentNode.removeChild(pdf)
              const style = document.getElementById('content').getElementsByTagName('style')
              for (let i = 0; i < style.length; i++) {
                style[i].parentNode.removeChild(style[i])
              }
              temp = null
            })
          })
        }, 600)
      },
      downloadPDFCommisionShipment (pages, opt) {
        this.busyCommisionShipment = true
        const promise = new Promise((resolve) => {
          let worker = html2pdf().set(opt).from(pages[0]).toPdf()
          pages.slice(1).forEach(function (page) {
            worker = worker.get('pdf').then(function (pdf) {
              pdf.addPage()
            }).from(page).toContainer().toCanvas().toPdf()
          })
          worker.save().then(() => {
            resolve()
          })
        })
        promise.then(() => {
          this.busyCommisionShipment = false
        })
      },
      downloadDocumentXml () {
        const filename = this.$parent.documentId + '.xml'
        const dHref = document.createElement('a')
        const dBlob = new Blob([this.$parent.documentXml], { type: 'text/plain' })
        dHref.setAttribute('href', window.URL.createObjectURL(dBlob))
        dHref.setAttribute('download', filename)
        dHref.dataset.downloadurl = ['text/plain', dHref.download, dHref.href].join(':')
        dHref.click()
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
